(function () {
  'use strict';

  var STORAGE_KEY          = 'kelab_wishlist';
  var STORAGE_KEY_META     = 'kelab_wishlist_meta';
  var STORAGE_KEY_VARIANTS = 'kelab_wishlist_variants';
  var isLoggedIn = window.__kelabCustomer && window.__kelabCustomer.id;

  /* ══════════════════════════════════════════
     STORAGE
  ══════════════════════════════════════════ */
  function getLocal() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { return []; }
  }
  function setLocal(ids) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)); } catch (e) {}
  }
  function getMeta() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY_META) || '{}'); } catch (e) { return {}; }
  }
  function setMeta(meta) {
    try { localStorage.setItem(STORAGE_KEY_META, JSON.stringify(meta)); } catch (e) {}
  }
  function saveHandle(id, handle) {
    if (!id || !handle) return;
    var meta = getMeta();
    if (meta[String(id)] === handle) return;
    meta[String(id)] = handle;
    setMeta(meta);
  }
  function getHandle(id) {
    return getMeta()[String(id)] || null;
  }
  function saveVariant(productId, variantId) {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY_VARIANTS) || '{}');
      data[String(productId)] = String(variantId);
      localStorage.setItem(STORAGE_KEY_VARIANTS, JSON.stringify(data));
    } catch (e) {}
  }
  function getSavedVariants() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY_VARIANTS) || '{}'); } catch (e) { return {}; }
  }

  function getWishlist() { return getLocal(); }
  function setWishlist(ids) {
    setLocal(ids);
    if (isLoggedIn) saveToCustomer(ids);
    updateBadge();
  }
  function isWishlisted(id) {
    return getWishlist().indexOf(String(id)) !== -1;
  }
  function toggle(id, handle, variantId) {
    id = String(id);
    if (handle) saveHandle(id, handle);
    if (variantId) saveVariant(id, variantId);
    var list = getWishlist();
    var idx  = list.indexOf(id);
    var added;
    if (idx === -1) { list.push(id); added = true; }
    else            { list.splice(idx, 1); added = false; }
    setWishlist(list);
    return added;
  }

  /* ══════════════════════════════════════════
     CUSTOMER SYNC
  ══════════════════════════════════════════ */
  function saveToCustomer(ids) {
    var form = document.getElementById('kelab-wishlist-sync-form');
    if (!form) return;
    var input = form.querySelector('[name="customer[note]"]');
    if (input) input.value = 'wishlist:' + ids.join(',');
  }
  function loadFromCustomer() {
    var meta = window.__kelabCustomer && window.__kelabCustomer.note;
    if (!meta) return null;
    var match = meta.match(/wishlist:([^|]*)/);
    if (!match) return null;
    return match[1] ? match[1].split(',').filter(Boolean) : [];
  }
  function mergeWishlists() {
    if (!isLoggedIn) return;
    var remote = loadFromCustomer();
    var local  = getLocal();
    if (remote === null) { if (local.length) saveToCustomer(local); return; }
    var merged = remote.concat(local).filter(function (v, i, a) { return a.indexOf(v) === i; });
    setLocal(merged);
    saveToCustomer(merged);
  }

  /* ══════════════════════════════════════════
     URL SHARE PARAMS
  ══════════════════════════════════════════ */
  function getSharedEntries() {
    try {
      var params = new URLSearchParams(window.location.search);
      var wl = params.get('wl');
      if (!wl) return null;
      return wl.split(',').map(function (chunk) {
        chunk = chunk.trim();
        var parts = chunk.split(':');
        return { id: parts[0], variantId: parts[1] || null };
      }).filter(function (e) { return e.id; });
    } catch (e) {}
    return null;
  }

  function buildShareUrl() {
    var ids      = getWishlist();
    var variants = getSavedVariants();
    var url      = window.location.origin + '/pages/wishlist';
    if (!ids.length) return url;
    var chunks = ids.map(function (id) {
      var vid = variants[String(id)];
      return vid ? id + ':' + vid : id;
    });
    return url + '?wl=' + chunks.join(',');
  }

  /* ══════════════════════════════════════════
     BADGE
  ══════════════════════════════════════════ */
  function updateBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('.kelab-wishlist-badge').forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
    var headerLink = document.querySelector('.kelab-wishlist-header-link');
    if (headerLink) {
      if (count > 0) {
        headerLink.setAttribute('data-has-items', 'true');
      } else {
        headerLink.removeAttribute('data-has-items');
      }
    }
  }

  /* ══════════════════════════════════════════
     HEART BUTTONS
  ══════════════════════════════════════════ */
  function setButtonState(btn, wishlisted) {
    btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
    var icon = btn.querySelector('.kelab-heart-icon');
    if (!icon) return;
    icon.setAttribute('data-filled', wishlisted ? 'true' : 'false');
    var outline = icon.querySelector('.kelab-heart-outline');
    var filled  = icon.querySelector('.kelab-heart-filled');
    if (outline) outline.style.setProperty('opacity', wishlisted ? '0' : '1', 'important');
    if (filled) {
      filled.style.setProperty('display',    'block',   'important');
      filled.style.setProperty('visibility', 'visible', 'important');
      filled.style.setProperty('opacity', wishlisted ? '1' : '0', 'important');
      if (wishlisted) {
        filled.style.setProperty('fill',  '#df3400', 'important');
        filled.style.setProperty('color', '#df3400', 'important');
        filled.setAttribute('fill', '#df3400');
        filled.querySelectorAll('path, circle, polygon').forEach(function (el) {
          el.style.setProperty('fill', '#df3400', 'important');
          el.setAttribute('fill', '#df3400');
        });
      } else {
        filled.style.setProperty('fill',  'none', 'important');
        filled.style.setProperty('color', '',     'important');
        filled.setAttribute('fill', 'none');
        filled.querySelectorAll('path, circle, polygon').forEach(function (el) {
          el.style.setProperty('fill', 'none', 'important');
          el.setAttribute('fill', 'none');
        });
      }
    }
  }

  function handleButtonClick(e) {
    e.preventDefault();
    var btn       = e.currentTarget;
    var id        = String(btn.dataset.productId);
    var handle    = btn.dataset.productHandle || null;
    var variantId = btn.dataset.variantId || null;
    var variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) variantId = variantInput.value;
    var added = toggle(id, handle, variantId);
    document.querySelectorAll('.kelab-wishlist-btn[data-product-id="' + id + '"]').forEach(function (b) {
      setButtonState(b, added);
    });
    btn.classList.remove('kelab-heart-pop');
    void btn.offsetWidth;
    btn.classList.add('kelab-heart-pop');
  }

  function initButton(btn) {
    var id     = String(btn.dataset.productId);
    var handle = btn.dataset.productHandle;
    if (id && handle) saveHandle(id, handle);
    setButtonState(btn, isWishlisted(id));
    if (btn._kelabInit) return;
    btn._kelabInit = true;
    btn.addEventListener('click', handleButtonClick);
  }

  function initAllButtons() {
    document.querySelectorAll('.kelab-wishlist-btn').forEach(initButton);
  }

  /* ══════════════════════════════════════════
     IMAGE HELPERS
  ══════════════════════════════════════════ */
  function getSrc(img) {
    var src = typeof img === 'string' ? img : (img && img.src ? img.src : '');
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function normSrc(src) {
    if (!src) return '';
    return src
      .replace(/^https?:/, '')
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|\d*x\d+)(\.(jpg|jpeg|png|gif|webp|avif))/i, '$2')
      .replace(/\?.*$/, '')
      .toLowerCase();
  }

  function imgUrl(src, size) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    src = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|\d*x\d+)(\.(jpg|jpeg|png|gif|webp|avif))/i, '$2');
    src = src.replace(/(\.(jpg|jpeg|png|gif|webp|avif))(\?|$)/i, '_' + size + 'x$1$3');
    return src;
  }

  /* ══════════════════════════════════════════
     MEDIA GROUPING
     Grouped by Color (option1) only.
     Format: ["ColorName,startPos,endPos", ...]
     startPos is 1-based image index.
  ══════════════════════════════════════════ */
  function getGroupings() {
    if (window.__kelabMediaGroupings && Object.keys(window.__kelabMediaGroupings).length) {
      return window.__kelabMediaGroupings;
    }
    try { return JSON.parse(localStorage.getItem('kelab_media_groupings') || '{}'); } catch (e) { return {}; }
  }

  // Get color option1 value from a variant or select elements in a card
  function getColorOption(variant) {
    // option1 is always Color for KELAB products
    return variant ? (variant.option1 || null) : null;
  }

  // Get grouped images for a color value (option1)
  function getImagesForColor(product, colorValue) {
    if (!colorValue) return [product.images[0] || null, product.images[1] || null];

    var groupings       = getGroupings();
    var productGrouping = groupings[product.id] ||
                          groupings[String(product.id)] ||
                          groupings[Number(product.id)];

    if (productGrouping && productGrouping.length) {
      var key = colorValue.toLowerCase().trim();
      for (var gi = 0; gi < productGrouping.length; gi++) {
        var raw  = productGrouping[gi];
        // Parse from the right: last two comma-separated values are numbers
        var last  = raw.lastIndexOf(',');
        var second = raw.lastIndexOf(',', last - 1);
        var grpKey = raw.substring(0, second).toLowerCase().trim();
        var start  = parseInt(raw.substring(second + 1, last));
        if (grpKey === key && !isNaN(start)) {
          return [product.images[start - 1] || null, product.images[start] || null];
        }
      }
    }

    // Fallback to images[0]/[1]
    return [product.images[0] || null, product.images[1] || null];
  }

  // Get images for a variant — uses color (option1) for grouping
  function getVariantImages(product, variant) {
    var colorValue = getColorOption(variant);
    // If no variant, use first variant's color
    if (!colorValue && product.variants && product.variants[0]) {
      colorValue = product.variants[0].option1 || null;
    }
    return getImagesForColor(product, colorValue);
  }

  // Get color value from current select state of a card
  function getColorFromCard(card, product) {
    // Color is option index 0 (first option)
    var colorGroup = card.querySelector('.kelab-wl-option-group[data-option-index="0"]');
    if (colorGroup) {
      var sel = colorGroup.querySelector('.kelab-wl-opt-select');
      if (sel && sel.value) return sel.value;
    }
    return null;
  }

  /* ══════════════════════════════════════════
     IMAGE WRAP HTML — shared helper
  ══════════════════════════════════════════ */
  function buildImgWrapHtml(product, colorValue) {
    var imgs   = getImagesForColor(product, colorValue);
    var priSrc = imgs[0] ? imgUrl(getSrc(imgs[0]), '400') : '';
    var secSrc = imgs[1] ? imgUrl(getSrc(imgs[1]), '400') : '';
    var alt    = product.title.replace(/"/g, '&quot;');
    var html   = '<a href="' + product.url + '" class="kelab-wl-img-wrap">';
    if (priSrc) {
      html += '<img class="kelab-wl-img kelab-wl-img-primary" src="' + priSrc + '" alt="' + alt + '" loading="lazy">';
    }
    if (secSrc && secSrc !== priSrc) {
      html += '<img class="kelab-wl-img kelab-wl-img-secondary" src="' + secSrc + '" alt="' + alt + '" loading="lazy">';
    }
    html += '</a>';
    return html;
  }

  /* ══════════════════════════════════════════
     FETCH PRODUCTS
  ══════════════════════════════════════════ */
  function fetchByHandle(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(function (p) {
        saveHandle(String(p.id), p.handle);
        var images = (p.images || []).filter(function (img) {
          return typeof img === 'string' ? img : (img && img.src);
        });
        var variants = (p.variants || []).map(function (v) {
          var fiSrc = v.featured_image ? getSrc(v.featured_image) : null;
          return {
            id:             v.id,
            price:          v.price,
            option1:        v.option1,
            option2:        v.option2,
            option3:        v.option3,
            available:      v.available,
            featured_image: fiSrc ? { src: fiSrc } : null
          };
        });
        var options = (p.options || []).map(function (o) {
          return { name: typeof o === 'string' ? o : o.name };
        });
        return {
          id:       String(p.id),
          title:    p.title || '',
          handle:   p.handle,
          url:      '/products/' + p.handle,
          images:   images,
          variants: variants,
          options:  options
        };
      })
      .catch(function () { return null; });
  }

  function fetchById(id, callback) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(id) + '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var results = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        for (var i = 0; i < results.length; i++) {
          if (String(results[i].id) === String(id)) {
            var url    = results[i].url || '';
            var handle = url.replace(/^.*\/products\//, '').split('?')[0];
            if (handle) { fetchByHandle(handle).then(callback); return; }
          }
        }
        callback(null);
      })
      .catch(function () { callback(null); });
  }

  function fetchProducts(entries, callback) {
    var products  = [];
    var completed = 0;
    var total     = entries.length;
    if (!total) { callback([]); return; }
    function done(p, variantId) {
      if (p) {
        p._requestedVariantId = variantId || null;
        products.push(p);
      }
      completed++;
      if (completed === total) callback(products);
    }
    entries.forEach(function (entry) {
      var id        = typeof entry === 'string' ? entry : entry.id;
      var variantId = typeof entry === 'string' ? null  : (entry.variantId || null);
      var handle    = getHandle(id);
      if (handle) {
        fetchByHandle(handle).then(function (p) {
          if (p) { done(p, variantId); return; }
          fetchById(id, function (p2) { done(p2, variantId); });
        });
      } else {
        fetchById(id, function (p) { done(p, variantId); });
      }
    });
  }

  /* ══════════════════════════════════════════
     WISHLIST PAGE RENDER
  ══════════════════════════════════════════ */
  function renderWishlistPage() {
    var container = document.getElementById('kelab-wishlist-page');
    if (!container) return;

    var sharedEntries = getSharedEntries();
    var isSharedView  = sharedEntries !== null;
    var entries;

    if (isSharedView) {
      entries = sharedEntries;
    } else {
      var ids      = getWishlist();
      var variants = getSavedVariants();
      entries = ids.map(function (id) {
        return { id: id, variantId: variants[String(id)] || null };
      });
    }

    if (isSharedView) {
      var shareWrap = document.querySelector('.kelab-wl-share-wrap');
      if (shareWrap) shareWrap.style.display = 'none';
      var header = document.querySelector('.kelab-wl-page-header');
      if (header && !document.getElementById('kelab-wl-shared-banner')) {
        var banner = document.createElement('p');
        banner.id = 'kelab-wl-shared-banner';
        banner.style.cssText = 'font-size:12px;font-family:Open Sans,sans-serif;font-weight:500;letter-spacing:-0.02em;color:#1a1a1a;opacity:0.6;margin:0;';
        banner.textContent = 'Viewing a shared wishlist';
        header.insertBefore(banner, header.firstChild);
      }
    }

    if (!entries.length) {
      container.innerHTML = isSharedView
        ? '<p class="kelab-wishlist-empty">This shared wishlist is empty.</p>'
        : '<p class="kelab-wishlist-empty">Your wishlist is empty. <a href="/collections/all" style="color:#1a1a1a;text-decoration:underline">Browse products</a></p>';
      return;
    }

    container.innerHTML = '<div class="kelab-wishlist-loading">Loading your wishlist...</div>';
    fetchProducts(entries, function (products) {
      if (!products.length) {
        container.innerHTML = '<p class="kelab-wishlist-empty">Could not load wishlist. <a href="/collections/all" style="color:#1a1a1a;text-decoration:underline">Browse products</a></p>';
        return;
      }
      drawGrid(container, products, isSharedView);
    });
  }

  /* ══════════════════════════════════════════
     HELPERS
  ══════════════════════════════════════════ */
  function formatMoney(price) {
    if (!price) return '';
    var amount = parseFloat(price);
    if (isNaN(amount)) return String(price);
    if (amount > 1000) amount = amount / 100;
    return '$' + amount.toFixed(2);
  }

  function findVariant(product, selectedOptions) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (v['option' + (j + 1)] !== selectedOptions[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function findVariantById(product, variantId) {
    if (!variantId) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) return product.variants[i];
    }
    return null;
  }

  function allOptionsSelected(card) {
    var ok = true;
    card.querySelectorAll('.kelab-wl-option-group').forEach(function (g) {
      var s = g.querySelector('.kelab-wl-opt-select');
      if (s && s.value === '') ok = false;
    });
    return ok;
  }

  function getOptionLabel(optionName, productTitle) {
    var name  = optionName.toLowerCase();
    var title = productTitle.toLowerCase();
    if (name === 'color' || name === 'colour' || name === 'case type') {
      if (title.indexOf('phone case') !== -1 || title.indexOf('iphone case') !== -1 ||
          title.indexOf('samsung case') !== -1) {
        return 'Case Type';
      }
    }
    return optionName;
  }

  /* ══════════════════════════════════════════
     BUILD CARD HTML
  ══════════════════════════════════════════ */
  function buildCardHtml(p, isSharedView) {
    var hasOptions = p.options && p.options.length &&
                     !(p.options.length === 1 && p.options[0].name === 'Title');

    var requestedVid = p._requestedVariantId || null;
    if (!requestedVid && !isSharedView) {
      requestedVid = getSavedVariants()[String(p.id)] || null;
    }

    var initialVariant = findVariantById(p, requestedVid) || (p.variants[0] || null);
    var initialColor   = getColorOption(initialVariant);

    var price = '';
    if (initialVariant) {
      price = formatMoney(initialVariant.price);
    } else if (p.variants.length) {
      var prices = p.variants.map(function (v) { return parseFloat(v.price); });
      var minP   = Math.min.apply(null, prices);
      var maxP   = Math.max.apply(null, prices);
      price = minP === maxP
        ? formatMoney(p.variants[0].price)
        : 'From ' + formatMoney(String(minP));
    }

    var html = '<div class="kelab-wl-card" data-product-id="' + p.id + '">';

    // Image wrap — uses color (option1) for grouping
    html += buildImgWrapHtml(p, initialColor);

    html += '<div class="kelab-wl-body">';
    html += '<a href="' + p.url + '" class="kelab-wl-title-link">';
    html += '<span class="kelab-wl-title-inner">' + p.title + '</span></a>';
    html += '<p class="kelab-wl-price">' + price + '</p>';

    if (hasOptions) {
      html += '<div class="kelab-wl-options">';
      p.options.forEach(function (opt, optIdx) {
        var optName = typeof opt === 'string' ? opt : opt.name;
        var values  = [];
        p.variants.forEach(function (v) {
          var val = v['option' + (optIdx + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        var label       = getOptionLabel(optName, p.title);
        var preSelected = initialVariant ? (initialVariant['option' + (optIdx + 1)] || '') : '';
        html += '<div class="kelab-wl-option-group" data-option-index="' + optIdx + '">';
        html += '<select class="kelab-wl-opt-select" data-option-index="' + optIdx + '">';
        html += '<option value=""' + (preSelected ? '' : ' selected') + '>Select ' + label + '</option>';
        values.forEach(function (val) {
          html += '<option value="' + val.replace(/"/g, '&quot;') + '"' + (val === preSelected ? ' selected' : '') + '>' + val + '</option>';
        });
        html += '</select></div>';
      });
      html += '</div>';
    }

    var canAtc      = !hasOptions || (initialVariant && requestedVid);
    var available   = initialVariant ? initialVariant.available : true;
    var atcLabel    = canAtc && !available ? 'Sold Out' : 'Add to Cart';
    var atcDisabled = (!canAtc || (canAtc && !available)) ? ' disabled' : '';
    var variantAttr = initialVariant ? ' data-variant-id="' + initialVariant.id + '"' : '';

    html += '<div class="kelab-wl-actions">';
    html += '<button class="kelab-wl-atc" data-product-id="' + p.id + '" data-handle="' + p.handle + '"' + variantAttr + atcDisabled + ' type="button">' + atcLabel + '</button>';
    if (!isSharedView) {
      html += '<button class="kelab-wl-remove" data-product-id="' + p.id + '" aria-label="Remove" type="button">';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      html += '</button>';
    }
    html += '</div></div></div>';
    return html;
  }

  /* ══════════════════════════════════════════
     MARQUEE
  ══════════════════════════════════════════ */
  function initMarquees(container) {
    container.querySelectorAll('.kelab-wl-title-link').forEach(function (link) {
      var inner  = link.querySelector('.kelab-wl-title-inner');
      if (!inner) return;
      var animId = null;
      link.addEventListener('mouseenter', function () {
        var linkW = link.offsetWidth;
        var textW = inner.scrollWidth;
        if (textW <= linkW) return;
        var distance = textW - linkW;
        var duration = distance / 40;
        var start    = null;
        inner.style.transition = 'none';
        inner.style.transform  = 'translateX(0)';
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / 1000 / duration, 1);
          inner.style.transform = 'translateX(-' + (progress * distance) + 'px)';
          if (progress < 1) animId = requestAnimationFrame(step);
        }
        animId = requestAnimationFrame(step);
      });
      link.addEventListener('mouseleave', function () {
        if (animId) { cancelAnimationFrame(animId); animId = null; }
        inner.style.transition = 'transform 0.3s ease';
        inner.style.transform  = 'translateX(0)';
      });
    });
  }

  /* ══════════════════════════════════════════
     DRAW GRID
  ══════════════════════════════════════════ */
  function drawGrid(container, products, isSharedView) {
    window._kelabWlProducts = {};
    products.forEach(function (p) { window._kelabWlProducts[p.id] = p; });
    var html = '<div class="kelab-wl-grid">';
    products.forEach(function (p) { html += buildCardHtml(p, isSharedView); });
    html += '</div>';
    container.innerHTML = html;
    bindCardActions(container, isSharedView);
    initMarquees(container);
  }

  /* ══════════════════════════════════════════
     BIND CARD INTERACTIONS
  ══════════════════════════════════════════ */
  function getSelectedOptions(card) {
    var opts = [];
    card.querySelectorAll('.kelab-wl-option-group').forEach(function (group) {
      var select = group.querySelector('.kelab-wl-opt-select');
      opts.push(select ? select.value : '');
    });
    return opts;
  }

  function updateCardForVariant(card, product, variant, colorValue) {
    var atcBtn = card.querySelector('.kelab-wl-atc');

    // ── Always update image when color changes, even if not all options selected ──
    if (colorValue) {
      var imgWrap = card.querySelector('.kelab-wl-img-wrap');
      if (imgWrap) {
        var tmp = document.createElement('div');
        tmp.innerHTML = buildImgWrapHtml(product, colorValue);
        imgWrap.parentNode.replaceChild(tmp.firstChild, imgWrap);
      }
    }

    // ── If not all options selected, disable ATC and stop ──
    if (!allOptionsSelected(card) || !variant) {
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Add to Cart'; delete atcBtn.dataset.variantId; }
      return;
    }

    // All options selected — save and update ATC
    saveVariant(product.id, variant.id);
    product._requestedVariantId = String(variant.id);

    var priceEl = card.querySelector('.kelab-wl-price');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (atcBtn) {
      atcBtn.dataset.variantId = variant.id;
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
      }
    }
  }

  function bindCardActions(container, isSharedView) {
    container.querySelectorAll('.kelab-wl-opt-select').forEach(function (select) {
      select.addEventListener('change', function () {
        var card    = select.closest('.kelab-wl-card');
        var pid     = card.dataset.productId;
        var product = window._kelabWlProducts && window._kelabWlProducts[pid];
        if (!product) return;

        // Get current color value (option index 0) regardless of other selects
        var colorValue = getColorFromCard(card, product);

        var opts    = getSelectedOptions(card);
        var variant = opts.indexOf('') !== -1 ? null : findVariant(product, opts);

        updateCardForVariant(card, product, variant, colorValue);
      });
    });

    if (!isSharedView) {
      container.querySelectorAll('.kelab-wl-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id   = String(btn.dataset.productId);
          var list = getWishlist();
          var idx  = list.indexOf(id);
          if (idx !== -1) list.splice(idx, 1);
          setWishlist(list);
          var card = container.querySelector('.kelab-wl-card[data-product-id="' + id + '"]');
          if (card) {
            card.style.opacity    = '0';
            card.style.transition = 'opacity 0.3s ease';
            setTimeout(function () {
              card.remove();
              if (!container.querySelectorAll('.kelab-wl-card').length) {
                container.innerHTML = '<p class="kelab-wishlist-empty">Your wishlist is empty. <a href="/collections/all" style="color:#1a1a1a;text-decoration:underline">Browse products</a></p>';
              }
            }, 300);
          }
        });
      });
    }

    container.querySelectorAll('.kelab-wl-atc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var variantId = btn.dataset.variantId;
        var handle    = btn.dataset.handle;
        if (variantId) {
          addToCart(Number(variantId), btn);
        } else {
          btn.textContent = 'Adding...'; btn.disabled = true;
          fetch('/products/' + handle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (p) {
              var v = p.variants && p.variants.length ? p.variants[0] : null;
              if (!v) throw new Error('no variant');
              addToCart(v.id, btn);
            })
            .catch(function () { btn.textContent = 'Add to Cart'; btn.disabled = false; });
        }
      });
    });
  }

  function addToCart(variantId, btn) {
    btn.textContent = 'Adding...'; btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (lineItem) {
      btn.textContent = 'Added!';

      // Fade out and remove the wishlist card
      var card = btn.closest('.kelab-wl-card');
      if (card) {
        card.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
        card.style.opacity    = '0';
        card.style.transform  = 'scale(0.96)';
        setTimeout(function () {
          var container = card.closest('#kelab-wishlist-page');
          card.remove();
          if (container && !container.querySelectorAll('.kelab-wl-card').length) {
            container.innerHTML = '<p class="kelab-wishlist-empty">Your wishlist is empty. <a href="/collections/all" style="color:#1a1a1a;text-decoration:underline">Browse products</a></p>';
          }
        }, 400);
      }

      // Open cart drawer via product:added event (theme listens to this)
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { quantity: 1, variant: lineItem }
      }));
    })
    .catch(function () { btn.textContent = 'Add to Cart'; btn.disabled = false; });
  }

  /* ══════════════════════════════════════════
     OBSERVE NEW BUTTONS
  ══════════════════════════════════════════ */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('kelab-wishlist-btn')) initButton(node);
        if (node.querySelectorAll) node.querySelectorAll('.kelab-wishlist-btn').forEach(initButton);
      });
    });
  });
  if (!(window.Shopify && Shopify.designMode)) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ══════════════════════════════════════════
     BOOT
  ══════════════════════════════════════════ */
  mergeWishlists();
  initAllButtons();
  updateBadge();
  renderWishlistPage();

  window.addEventListener('load', function () {
    initAllButtons();
    updateBadge();
  });

  window.KelabWishlist = {
    toggle:         toggle,
    isWishlisted:   isWishlisted,
    getWishlist:    getWishlist,
    updateBadge:    updateBadge,
    initAllButtons: initAllButtons,
    buildShareUrl:  buildShareUrl
  };

}());